import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyDBC9epIKcRv7eAsq8wrvFdFMgIZWjwDCE",
  authDomain: "mo-fidelite.firebaseapp.com",
  databaseURL: "https://mo-fidelite.firebaseio.com",
  projectId: "mo-fidelite",
  storageBucket: "mo-fidelite.appspot.com",
  messagingSenderId: "791741922053",
  appId: "1:791741922053:web:1f487a7cf9b8470b94156c",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
export const db = firebase.firestore();
// if (location.hostname === 'localhost') {
//   db.settings({
//     host: 'localhost:8080',
//     ssl: false,
//   });
// }
export const auth = firebase.auth();
export const functions = firebase.app().functions("europe-west3");
